module.exports = __webpack_public_path__ + "static/media/nodata-timer.097ba697.svg";